module.exports = __webpack_public_path__ + "img/uppa_cropped_scaled.876d3afe.png";